const branchObj = [
    {
        id: 1,
        branchNameUz: "Shaxriston",
        branchNameEng: "Shakhristan",
        landmark: "In front of metro",
        workingHours: "09:00 - 20:00",
    },
    {
        id: 2,
        branchNameUz: "Xadra fast food",
        branchNameEng: "Xadra fast food",
        landmark: "Next to Royson",
        workingHours: "09:00 - 20:00",
    },
    {
        id: 3,
        branchNameUz: "Maksim Gorgiy",
        branchNameEng: "Maksim Gorgiy",
        landmark: "In front of metro",
        workingHours: "09:00 - 20:00",
    },
]
export default branchObj;